'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = angular.module('winresCloud.winresCloud', ['winresCloud.core' //For userService
]);


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/module.js
// module id = 554
// module chunks = 2